import React, { useState } from 'react';

export default function ButtonCheckBoxLabel({ onClick, tipoCuenta, label }) {


    const handleClick = (option) => {
        onClick(option);
    };

    return (
        <div className="flex items-center space-x-4">
            {/* Opción "Ahorros" */}
            <div
                className={`
          flex items-center space-x-2 
          border border-transparent 
          rounded-lg 
          bg-[#2B2B33]
          px-3 py-2 
          cursor-pointer 
          transition
          ${tipoCuenta === label ? 'border-white' : ''}
        `}
                onClick={() => handleClick(label)}
            >
                {/* Círculo que simula el bullet del "radio" */}
                <div
                    className={`
            h-4 w-4 
            rounded-full 
            border border-gray-400 
            flex items-center justify-center
            ${tipoCuenta === label ? 'border-white' : 'border-transparent'}
          `}
                >
                    {tipoCuenta === label && (
                        <div className="h-2 w-2 bg-white rounded-full" />
                    )}
                </div>
                <span className="text-sm font-medium text-white">{label}</span>
            </div>


        </div>
    );
}
